<template>
  <div class="config">
    <div class="w3-container">
      <div class="headerGrid">
        <header>
          <h2>Domains</h2>
        </header>
        <div>
          <button class="w3-button w3-green w3-small w3-right vmiddle" @click="updateDomains()">Save</button>
        </div>
      </div>
      <div class="w3-white outline">
        <div class="w3-container w3-padding-v">
          <div class="w3-row w3-padding-bottom">
            <div class="w3-col s12" :class="config.domains.registrar == 'resellerclub' ? 'm4':''">
              <div class="w3-container">
                <label>Registrar</label>
                <select class="w3-select w3-border" v-model="config.domains.registrar">
                  <option disabled value="choose">Choose Domain Registrar</option>
                  <option value="resellerclub">ResellerClub</option>
                </select>
              </div>
            </div>
            <template v-if="config.domains.registrar == 'resellerclub'">
              <div class="w3-col s12 m4">
                <div class="w3-container">
                  <label>User ID</label>
                  <input class="w3-input w3-border w3-hover-border-black" type="text" v-model="config.domains.userid" placeholder="User ID">
                </div>
              </div>
              <div class="w3-col s12 m4">
                <div class="w3-container">
                  <label>API Key</label>
                  <input class="w3-input w3-border w3-hover-border-black" type="text" v-model="config.domains.apikey" placeholder="API Key">
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dataStore from '../dataStore';

export default {
  name: "config",
  data: function() {
    return {
      config: {
        domains: {
          registrar: "",
          userid: "",
          apikey: ""
        }
      },
    };
  },
  created() {
    dataStore.getConfig().then((res) => {
      if (res === 'success') {
        this.config = {
          domains: JSON.parse(dataStore.state.config[0].domains),
          invoices: JSON.parse(dataStore.state.config[0].invoices),
          clients: JSON.parse(dataStore.state.config[0].clients),
        }
        console.log(this.config)
      }
    })
  },
  methods: {
    updateDomains() {
      dataStore.saveConfig('domains', JSON.stringify(this.config.domains))
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Config.vue